export const channelType: any = {
  virtual_bank_account: 'Virtual Bank Account',
  retail: 'Retail',
  ewallet: 'E-Wallet',
  cc: 'Credit Card',
}